import React, { useState } from "react";
import { Col, Card } from "react-bootstrap";
import { useNavigate } from "react-router";
import { activateMenu } from "redux/actions";
import { useAppDispatch } from "redux/store";
type Props = {
    id:number;
    gramam_name: string;
    gramams_formed: number;
    members_registered :number;
    total_basti :number;
    nagar_type:number;
    total_gramas :number;
};
export const GramamReportCard: React.FC<Props> = ({ id, nagar_type,gramam_name,gramams_formed,members_registered,total_basti ,total_gramas}) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const handleCardClick = (id) => {
        // dispatch(activateMenu(path))
        localStorage.setItem('gramam_name',gramam_name)
        navigate('/samithi_members/'+id, { replace: true });
    }
    return (
        <Col md={4} xl={3} xs={6} className="cursor-pointer mb-4" onClick={() => { handleCardClick(id); }}>
      <Card className=" shadow h-100 py-2" style={{ borderLeft: members_registered > 0 ? '5px solid #194380' : '5px solid #FF0000' }}>
      <Card.Body style={{padding :"2.5rem"}}>
                    <div className="row no-gutters align-items-center">
                        <div className="col mr-2">
                            <div className="text-xl font-weight-bold  text-uppercase mb-1" style={{ color: members_registered > 0 ? '#194380' : '#FF0000' }}>
                                <p>{gramam_name}</p></div>
                            <div className=" mb-0 font-weight-bold text-gray-800"></div>
                        </div>
                        <div className=" mb-0 font-weight-bold text-gray-800">
                        {total_gramas >0 &&
                 <p>{members_registered}  Addresses Registered  </p>
}
                        </div>

                    </div>
                </Card.Body>
            </Card>
        </Col>
    );
};

